import { fetchPageAssets } from '../../ducks/hostedAssets.duck';
export const TERMS_OF_SERVICE_ASSET_KEY = 'termsOfService';
export const PRIVACY_POLICY_ASSET_KEY = 'privacyPolicy';

export const loadData = (params, search, config, intl) => dispatch => {
  const termsOfServiceAssetName = intl?.messages?.['CMSPage.termsOfService'] || 'terms-of-service';
  const privacyPolicyAssetName = intl?.messages?.['CMSPage.privacyPolicy'] || 'privacy-policy';

  const pageAsset = {
    [TERMS_OF_SERVICE_ASSET_KEY]: `content/pages/${termsOfServiceAssetName}.json`,
    [PRIVACY_POLICY_ASSET_KEY]: `content/pages/${privacyPolicyAssetName}.json`,
  };
  return dispatch(fetchPageAssets(pageAsset, true));
};
